import { render } from "./UnreadNewsPopup.vue?vue&type=template&id=4395e816&scoped=true"
import script from "./UnreadNewsPopup.vue?vue&type=script&lang=js"
export * from "./UnreadNewsPopup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4395e816"]])

export default __exports__